var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step_item"},[_c('Table',{attrs:{"list":_vm.list,"title":_vm.title,"play":_vm.play}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }